var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showModal)?_c('BaseModal',{attrs:{"display-close-button":_vm.displayCloseButtonState}},[_c(_vm.currentModal,{tag:"component",attrs:{"data":_vm.currentModalData}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }